module.exports = __webpack_public_path__ + "img/details-two.d0687c75.png";